import React from 'react';
import ApplyToDriveEdit from '../../profile/components/update-license/ApplyToDriveEdit';

export default function AddLicenseScreen(props){
  return <ApplyToDriveEdit findAVan={true} history={props.history} navigateTo="/JoinCommute/verify/home-address" presentRoute="/license/add-license" flow="findAVan"/>
}